import React, {FC} from 'react';

import {Anchor} from '../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {AiAnswersShowcaseAiAnswersEducationTip} from './aiAnswersShowcaseAiAnswersEducationTip';
import {SandboxEducationTipCoordinator} from './sandboxEducationTipCoordinator';

/*
 * Props.
 */

interface AiAnswersShowcaseAiAnswersEducationTipCoordinatorProps {
  anchor: Anchor;
  conversationId: number | undefined;
}

/*
 * Component.
 */

export const AiAnswersShowcaseAiAnswersEducationTipCoordinator: FC<
  AiAnswersShowcaseAiAnswersEducationTipCoordinatorProps
> = (props) => (
  <SandboxEducationTipCoordinator
    anchor={props.anchor}
    conversationId={props.conversationId}
    scenario={SandboxScenariosEnum.SCENARIO4_ACT4}
    step="showcase-ai-answers"
    isEligible
    renderEducationTip={(tipProps) => <AiAnswersShowcaseAiAnswersEducationTip {...tipProps} />}
    // Wait a bit while the chat widget smoothly scrolls into position.
    delay={500}
  />
);
